import { create } from "zustand";

const DEFAULT_HEADER_STATE = {
  isShowingMenu: false,
  isShowingMobileSearch: false,
  isShowingAccountMenu: false,
  isSearchVisible: false,
  query: "",
};

type HeaderStore = {
  isShowingMenu: boolean;
  isShowingMobileSearch: boolean;
  isShowingAccountMenu: boolean;
  isSearchVisible: boolean;
  query: string;
  setIsShowingMenu: (isShowingMenu: boolean) => void;
  setIsShowingMobileSearch: (isShowingMobileSearch: boolean) => void;
  setIsShowingAccountMenu: (isShowingAccountMenu: boolean) => void;
  setIsSearchVisible: (isSearchVisible: boolean) => void;
  setQuery: (query: string) => void;
  resetInTests: () => void;
};

export const useHeaderStoreZustand = create<HeaderStore>((set) => ({
  ...DEFAULT_HEADER_STATE,
  setIsShowingMenu: (isShowingMenu: boolean) => set({ isShowingMenu }),
  setIsShowingMobileSearch: (isShowingMobileSearch: boolean) =>
    set({ isShowingMobileSearch }),
  setIsShowingAccountMenu: (isShowingAccountMenu: boolean) =>
    set({ isShowingAccountMenu }),
  setIsSearchVisible: (isSearchVisible: boolean) => set({ isSearchVisible }),
  setQuery: (query: string) => set({ query }),
  resetInTests: () =>
    set({
      ...DEFAULT_HEADER_STATE,
    }),
}));
